// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Questrial&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cinzel&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --heroHeadline: 40px "Montserrat", Arial, Helvetica, sans-serif;
    --heroHedlineColor: rgb(110, 110, 110);
    --accentColor: rgb(0, 51, 153);
    --colorHover: rgb(0, 118, 193);
    --aboutColor: var(--aboutColorMain);
    --aboutColorVarient: rgb(201, 226, 255);
    --aboutColorMain: rgb(253, 246, 240);
    --promoBG: rgba(0, 70, 209, 1);
    --IntastellarGrey: rgb(88, 88, 88);
    --IntastellarMediumGrey: rgb(156, 156, 156);
    --infoBanner: rgb(207, 207, 207);
    --infoBannerLigherShade: rgb(230, 230, 230);
    --infoBannerlightesShade: rgb(246, 246, 246);
    --infoBannerWarning: rgb(251, 237, 225);
    --infoBannerError: rgb(255, 183, 183);
    --statusBannerBg: var(--IntastellarMediumGrey);
    --cookieBanner: rgb(190, 211, 255);
    --borderRadius: 10px;
}

::-webkit-scrollbar{
    width: 2px;
    height: 2px;
}

::-webkit-scrollbar-track{
    background: transparent;
}

::-webkit-scrollbar-thumb{
    background: #888;
}

::-webkit-scrollbar-thumb:hover{
    background: #555;
}

::-webkit-scrollbar-thumb:active{
    background: #555;
}

*{
    box-sizing: border-box;
}

h1, h2, h3, h4, h5, h6{
    font-weight: lighter;
}

img{
    max-width: 100%;
}

body{
    background-color: rgb(55, 55, 55);
    color: rgb(197, 197, 197);
    font-family: "Questrial", Arial, Helvetica, sans-serif;
    margin: 0;
}

.grid-container{
    display: grid;
}

.overvieTotal-num {
    font-size: 2.7em;
    margin: 0px;
    margin-block-start: 1em;
    color: rgb(239, 239, 239);
}

.main-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    scroll-padding-top: 66px;
    padding-top: 66px;
}

.link{
    color: rgb(207, 207, 207);
    display: block;
    padding: 15px;
    text-decoration: none;
    text-align: left;
}

.backLink{
    text-decoration: none;
    color: #fff;
    padding: 15px 0px;
    margin: 10px 0px;
    display: block;
    position: relative;
    display: inline-flex;
}

.backLink::before{
    content: "";
    width: 10px;
    height: 10px;
    margin-right: 10px;
    display: block;
    border-top: 1px solid;
    border-left: 1px solid;
    transform: rotate(-45deg);
}

.lb{
    line-break: anywhere;
}

.crawler{
    background-color: #ffffff;
    position: relative;
    padding: 15px;
    color: #525252;
    border-radius: 10px;
}

.cookieCheckContainer{
    width: 1200px;
    margin: auto;
    display: grid;
    place-items: center;
    height: 100vh;
}

.cookieCheckContainer h2{
    font-size: 2.5em;
}

.crawlerPage-logo{
    max-width: 200px;
}

.cookieCheckContainer .form{
    width: 100%;
}

.infoHeader{
    width: 100%;
    position: relative;
    overflow: visible;
}

.infoHeader.sticky{
    position: sticky;
    top: 66px;
    left: 0;
    right: 0;
    z-index: 100;
    padding: 10px 0 !important;
    background-color: rgb(55, 55, 55);
    box-shadow: inset 0 1px 1px 0 rgba(0,0,0,.14),inset 0 2px 1px -1px rgba(209, 209, 209, 0.12);
}

.infoHeader.sticky::after{
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    bottom: -4px;
    box-shadow: inset 0 1px 1px 0 rgba(182, 182, 182, 0.14),inset 0 2px 1px -1px rgba(182, 182, 182,.12);
    content: "";
    height: 4px;
    left: 8px;
    mask-image: -webkit-gradient(linear,left top,right top,from(transparent),color-stop(5%,#000),color-stop(95%,#000),to(transparent));
    mask-image: linear-gradient(90deg,transparent,#000 5%,#000 95%,transparent);
    position: absolute;
    -webkit-mask-image: -webkit-gradient(linear,left top,right top,from(transparent),color-stop(5%,#000),color-stop(95%,#000),to(transparent));
    -webkit-mask-image: -webkit-linear-gradient(left,transparent,#000 5%,#000 95%,transparent);
    width: calc(100% - 16px);
}

.border{
    border: 1px solid rgb(95, 95, 95);
}

.no-gap{
    gap: 0 !important;
}

@media screen and (min-width: 320px) and (max-width: 900px) {
    .main-grid{
        display: block;
    }

    .cookieCheckContainer{
        width: 100%;
        padding: 10px;
    }

    .dashboard-content{
        padding: 0 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAIA;IACI,+DAA+D;IAC/D,sCAAsC;IACtC,8BAA8B;IAC9B,8BAA8B;IAC9B,mCAAmC;IACnC,uCAAuC;IACvC,oCAAoC;IACpC,8BAA8B;IAC9B,kCAAkC;IAClC,2CAA2C;IAC3C,gCAAgC;IAChC,2CAA2C;IAC3C,4CAA4C;IAC5C,uCAAuC;IACvC,qCAAqC;IACrC,8CAA8C;IAC9C,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,sDAAsD;IACtD,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;;IAEf,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,0BAA0B;IAC1B,iCAAiC;IACjC,4FAA4F;AAChG;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,YAAY;IACZ,oGAAoG;IACpG,WAAW;IACX,WAAW;IACX,SAAS;IACT,kIAAkI;IAClI,2EAA2E;IAC3E,kBAAkB;IAClB,0IAA0I;IAC1I,0FAA0F;IAC1F,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url(\"https://fonts.googleapis.com/css2?family=Questrial&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Cinzel&display=swap\");\n\n:root{\n    --heroHeadline: 40px \"Montserrat\", Arial, Helvetica, sans-serif;\n    --heroHedlineColor: rgb(110, 110, 110);\n    --accentColor: rgb(0, 51, 153);\n    --colorHover: rgb(0, 118, 193);\n    --aboutColor: var(--aboutColorMain);\n    --aboutColorVarient: rgb(201, 226, 255);\n    --aboutColorMain: rgb(253, 246, 240);\n    --promoBG: rgba(0, 70, 209, 1);\n    --IntastellarGrey: rgb(88, 88, 88);\n    --IntastellarMediumGrey: rgb(156, 156, 156);\n    --infoBanner: rgb(207, 207, 207);\n    --infoBannerLigherShade: rgb(230, 230, 230);\n    --infoBannerlightesShade: rgb(246, 246, 246);\n    --infoBannerWarning: rgb(251, 237, 225);\n    --infoBannerError: rgb(255, 183, 183);\n    --statusBannerBg: var(--IntastellarMediumGrey);\n    --cookieBanner: rgb(190, 211, 255);\n    --borderRadius: 10px;\n}\n\n::-webkit-scrollbar{\n    width: 2px;\n    height: 2px;\n}\n\n::-webkit-scrollbar-track{\n    background: transparent;\n}\n\n::-webkit-scrollbar-thumb{\n    background: #888;\n}\n\n::-webkit-scrollbar-thumb:hover{\n    background: #555;\n}\n\n::-webkit-scrollbar-thumb:active{\n    background: #555;\n}\n\n*{\n    box-sizing: border-box;\n}\n\nh1, h2, h3, h4, h5, h6{\n    font-weight: lighter;\n}\n\nimg{\n    max-width: 100%;\n}\n\nbody{\n    background-color: rgb(55, 55, 55);\n    color: rgb(197, 197, 197);\n    font-family: \"Questrial\", Arial, Helvetica, sans-serif;\n    margin: 0;\n}\n\n.grid-container{\n    display: grid;\n}\n\n.overvieTotal-num {\n    font-size: 2.7em;\n    margin: 0px;\n    margin-block-start: 1em;\n    color: rgb(239, 239, 239);\n}\n\n.main-grid {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n\n    scroll-padding-top: 66px;\n    padding-top: 66px;\n}\n\n.link{\n    color: rgb(207, 207, 207);\n    display: block;\n    padding: 15px;\n    text-decoration: none;\n    text-align: left;\n}\n\n.backLink{\n    text-decoration: none;\n    color: #fff;\n    padding: 15px 0px;\n    margin: 10px 0px;\n    display: block;\n    position: relative;\n    display: inline-flex;\n}\n\n.backLink::before{\n    content: \"\";\n    width: 10px;\n    height: 10px;\n    margin-right: 10px;\n    display: block;\n    border-top: 1px solid;\n    border-left: 1px solid;\n    transform: rotate(-45deg);\n}\n\n.lb{\n    line-break: anywhere;\n}\n\n.crawler{\n    background-color: #ffffff;\n    position: relative;\n    padding: 15px;\n    color: #525252;\n    border-radius: 10px;\n}\n\n.cookieCheckContainer{\n    width: 1200px;\n    margin: auto;\n    display: grid;\n    place-items: center;\n    height: 100vh;\n}\n\n.cookieCheckContainer h2{\n    font-size: 2.5em;\n}\n\n.crawlerPage-logo{\n    max-width: 200px;\n}\n\n.cookieCheckContainer .form{\n    width: 100%;\n}\n\n.infoHeader{\n    width: 100%;\n    position: relative;\n    overflow: visible;\n}\n\n.infoHeader.sticky{\n    position: sticky;\n    top: 66px;\n    left: 0;\n    right: 0;\n    z-index: 100;\n    padding: 10px 0 !important;\n    background-color: rgb(55, 55, 55);\n    box-shadow: inset 0 1px 1px 0 rgba(0,0,0,.14),inset 0 2px 1px -1px rgba(209, 209, 209, 0.12);\n}\n\n.infoHeader.sticky::after{\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    bottom: -4px;\n    box-shadow: inset 0 1px 1px 0 rgba(182, 182, 182, 0.14),inset 0 2px 1px -1px rgba(182, 182, 182,.12);\n    content: \"\";\n    height: 4px;\n    left: 8px;\n    mask-image: -webkit-gradient(linear,left top,right top,from(transparent),color-stop(5%,#000),color-stop(95%,#000),to(transparent));\n    mask-image: linear-gradient(90deg,transparent,#000 5%,#000 95%,transparent);\n    position: absolute;\n    -webkit-mask-image: -webkit-gradient(linear,left top,right top,from(transparent),color-stop(5%,#000),color-stop(95%,#000),to(transparent));\n    -webkit-mask-image: -webkit-linear-gradient(left,transparent,#000 5%,#000 95%,transparent);\n    width: calc(100% - 16px);\n}\n\n.border{\n    border: 1px solid rgb(95, 95, 95);\n}\n\n.no-gap{\n    gap: 0 !important;\n}\n\n@media screen and (min-width: 320px) and (max-width: 900px) {\n    .main-grid{\n        display: block;\n    }\n\n    .cookieCheckContainer{\n        width: 100%;\n        padding: 10px;\n    }\n\n    .dashboard-content{\n        padding: 0 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
